/* istanbul ignore file */
import { getMpAgent, MpxResponseBase } from '@cibo/core'

const mpAgent = getMpAgent()

const PATHS = {
  DEFS: '/operator/programDefs',
  DETAIL: '/operator/programDefs/:programId',
}

type SaveProgramDefRequest = {
  dryRun?: boolean
  programConfig: any
}

type ProgramDefRequest = {
  programId: string
}

type ProgramDef = {
  [key: string]: any
}

export class ProgramDefAPI {
  static getProgram({ programId, ...params }: ProgramDefRequest) {
    return mpAgent
      .get<ProgramDef>({ template: PATHS.DETAIL, params: { programId } }, { params })
      .then(response => response && response.data.programdef)
  }

  static saveProgram({ programConfig, dryRun }: SaveProgramDefRequest) {
    const request = {
      programdef: programConfig,

      // this seems to be a required param for persistence
      dryRun: dryRun ?? false,
    }

    return mpAgent
      .put<MpxResponseBase>(PATHS.DEFS, request)
      .then(response => response && response.data)
  }
}
